if (
  document.readyState === 'complete' 
  || document.readyState === 'loaded' 
  || document.readyState === 'interactive'
) {
  cookieInit();
} else {
  //Set event listener or timeout.
  document.addEventListener('DOMContentLoaded', cookieInit);
}

function cookieInit() {
  const cookieBtns = document.querySelectorAll('[data-sg-cookie]');
  cookieBtns.forEach(function(item) {
    if(item.tagName == 'BUTTON' || item.tagName == 'A') {
      item.addEventListener('click', preferenceMade);
    } else if(item.tagName == 'INPUT' || item.tagName == 'SELECT') {
      item.addEventListener('change', preferenceMade);
    }
    item.removeAttribute('disabled');
    if(item.dataset.sgCookieBtnEnabled) {
      item.setAttribute('class', item.dataset.sgCookieBtnEnabled);
    }
  });
  function preferenceMade(e) {
    document.cookie = `sg-cookie-policy-settings=${e.currentTarget.dataset.sgCookie};path=/;max-age=${31536000};secure`;
    const sgCookiePreferencesAfterUpdate = new CustomEvent("sgCookiePreferencesAfterUpdate", {
      detail: {
        preference: e.currentTarget.dataset.sgCookie,
      },
    });
    document.dispatchEvent(sgCookiePreferencesAfterUpdate);
  }
}